import Box from "../../designSystem/Box";
import Snackbar from "../../designSystem/Snackbar";
import { useTheme } from "../../designSystem";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Grid from "../../designSystem/Grid";
import IconButton from "../../designSystem/IconButton";
import Typography from "../../designSystem/Typography";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getPath } from "../../utils/navigation";
import { useNavigate } from "react-router-dom";

const AlertIcon = ({ type }) => {
  const iconSize = "18px";
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        height: "100%"
      }}
    >
      {type === "success" && <CheckCircleIcon color='success' sx={{ fontSize: iconSize }} />}
      {type === "info" && <InfoOutlinedIcon color='info' sx={{ fontSize: iconSize }} />}
      {type === "error" && <ErrorOutlineOutlinedIcon color='error' sx={{ fontSize: iconSize }} />}
    </div>
  );
};
const Alertcomp = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const uiState = useSelector((state) => state.uiStates);

  const alertCloseFn = () => {
    dispatch({ type: "uiStates/alertCloseFn" });
  };

  const alertClickMap = {
    redirectToDashboard: () => navigate(getPath("/dashboard/")),
    redirectToDownload: () => navigate(getPath("/workspace/?tab=downloads"))
  };

  //For backward handling
  const alertOpen = props?.alertOpen ?? uiState.alertOpen;
  const alertMsg = props?.msg ?? uiState.alertMsg;
  const alertType = props?.type ?? uiState.alertType;
  const alertClose = props?.alertClose ?? alertCloseFn;
  const alertClickFn = props?.onClick ?? alertClickMap[uiState.alertClickFn];
  const alertTime = props?.alertTime ?? uiState.alertTime;

  const iconStyle = {
    success: {
      backgroundColor: theme.palette.success[100],
      border: `1px solid ${theme.palette.success[200]}`
    },
    info: { backgroundColor: "#ebf5fe", border: `1px solid #b3e5fc` }, //need to use theme
    error: {
      backgroundColor: theme.palette.error[100],
      border: `1px solid ${theme.palette.error[200]}`
    }
  };

  const snackClose = (e, reason) => {
    if (reason === "clickaway") {
      return;
    }
    alertClose();
  };

  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      props?.alertClose && props?.alertClose();
    };
  }, []);

  return (
    <>
      <Snackbar
        open={alertOpen}
        anchorOrigin={{ vertical: "top", horizontal: "center", padding: "15px" }}
        autoHideDuration={alertTime || 5000}
        onClick={alertClickFn}
        sx={{ borderRadius: "8px" }}
        onClose={snackClose}
      >
        <Box
          sx={{
            minWidth: "300px",
            maxWidth: "500px",
            margin: "10px",
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "8px 12px 8px 12px",
            // bgcolor: "green",
            ...iconStyle[alertType],
            // border: "1px solid",
            position: "relative", // Add relative positioning
            boxShadow: (theme) => theme.shadows[3]
          }}
        >
          <Grid container>
            {/* <Grid
              item
              xs={2}
              sx={{ display: "flex", alignItems: "flex-start" }}

              // style={{ ...iconStyle[props.type], minHeight: "70px" }}
            >
              <AlertIcon type={props.type} error={props.error} />
            </Grid> */}

            {/* Content (10/12) */}
            <Grid
              item
              xs={10}
              sx={{ display: "flex", gap: "8px", flexDirection: "row", overflowX: "hidden" }}
            >
              {/* {props.type === "error" ? (
                <Typography
                  variant='body2'
                  lineHeight={1}
                  // component='div'
                  align='left'
                  // sx={{
                  //   display: "flex",
                  //   alignItems: "center",
                  //   height: "100%",
                  //   paddingRight: "4px"
                  // }}
                >
                  {t(msg)}
                </Typography>
              ) : ( */}
              <Box>
                <AlertIcon type={alertType} />
              </Box>
              <Box>
                <Typography
                  variant='h6'
                  lineHeight={1}
                  // component='div'
                  align='left'
                  textTransform={"capitalize"}
                >
                  {t(alertType)}
                </Typography>
                <Typography
                  variant='body2'
                  // component='div'
                  align='left'
                  sx={{ paddingRight: "4px" }}
                >
                  {t(alertMsg)}
                </Typography>
              </Box>

              {/* )} */}
            </Grid>

            {/* IconButton (2/12) */}
            <Grid
              item
              xs={2}
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-end"
                // position: "absolute", // Add absolute positioning
                // top: 0, // Align to the top
                // right: 0 // Align to the right
              }}
            >
              {/* {props.type !== "error" ? ( */}
              <IconButton
                size='small'
                onClick={() => {
                  alertClose();
                }}
                sx={{ padding: 0 }}
              >
                <CloseIcon fontSize='18px' />
              </IconButton>
              {/* // ) : null} */}
            </Grid>
          </Grid>
        </Box>
      </Snackbar>
      {props.children}
    </>
  );
};
export default Alertcomp;
